/**
 * @description Directory for ID Attributes on InputCaseBuilderDetailsStep2.
 * Naming Convention: "[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "mainlayout-btn-cancel".
 */
const idDirectory = {
    divRoot: `inputCaseBuilderDetailsStep2-div-root`,
}

export default idDirectory